import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useEffect, useState } from 'react';
import { useTranslation } from '@/hooks/useTranslation';

export function PrivateRoute() {
  const { isAuthenticated, isLoading, logout, isAuthChecked } = useAuth();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && isAuthChecked) {
      logout(); // clean logout
      setShouldRedirect(true); // trigger redirect
    }
  }, [isAuthChecked, isAuthenticated, isLoading, logout]);

  if (isLoading) return <div>{t('common.loading')}</div>;

  if (shouldRedirect) return <Navigate to="/auth" state={{ from: location }} />;

  return isAuthenticated ? <Outlet /> : null;
}
